// extracted by mini-css-extract-plugin
module.exports = {"main-title":"main-title--3xon0"};